import {
  GetLocationProcessorRequest,
  GetLocationProcessorResponse,
} from '@weave/schema-gen-ts/dist/schemas/payments-platform/payments-config/payments_config.pb';
import { CustomAxios } from 'redux/axios';

const PAYMENTS_CONFIG_BASE_URL = '/payments-platform/payments-config';

export const getJustifiProcessor = async ({
  locationId,
}: GetLocationProcessorRequest) => {
  const { data } = await CustomAxios.get<GetLocationProcessorResponse>(
    `${PAYMENTS_CONFIG_BASE_URL}/location/processor`,
    { params: { locationId } }
  );
  return data;
};
